import React from "react"

import Tooltip from '@material-ui/core/Tooltip';

import Row from "./Row";

import TemplateProperty from "../modal/TemplateProperty";

import General from "../../../utils/General";
import Form from "../../../utils/Form";
import AuthManager from "../../../utils/AuthManager";


export default class Section extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      section: props.section,
      index: props.index,
      level: props.level,
      group: props.group,
      editable: props.editable,
      submission: props.submission,
      subSectionsTitle: Form.getSubSectionsTitle(props.section),
      subSectionsCreatable: Form.getSubSectionsCreatable(props.section),
      subSectionCreatableTemplate: Form.getSubSectionCreatableTemplate(props.section)
    }

    this.rowRefs = {}
    this.subSectionRefs = {}
  }

  componentWillReceiveProps(props) {
    this.setState(props)
  }

  getErrors(){
    let errors = []
    Object.keys(this.rowRefs).map((key, index) => {
      let rowRef = this.rowRefs[index]
      errors = [
        ...errors,
        ...rowRef.getErrors()
      ]
    })
    Object.keys(this.subSectionRefs).map((key, index) => {
      let subSectionRef = this.subSectionRefs[index]
      errors = [
        ...errors,
        ...subSectionRef.getErrors()
      ]
    })
    return errors
  }

  getUnansweredRecommendedFields(){
    let { section } = this.state
    let unansweredRecommendedFields = []

    Object.keys(this.rowRefs).map((key, index) => {
      let rowRef = this.rowRefs[index]
      if(rowRef){
        unansweredRecommendedFields = [
          ...unansweredRecommendedFields,
          ...rowRef.getUnansweredRecommendedFields().map(field => {
            return {
              field,
              path: section.title + " -> " + field.title
            }
          })
        ]
      }
    })
    Object.keys(this.subSectionRefs).map((key, index) => {
      let subSectionRef = this.subSectionRefs[index]
      if(subSectionRef){
        unansweredRecommendedFields = [
          ...unansweredRecommendedFields,
          ...subSectionRef.getUnansweredRecommendedFields().map(o => {
            return {
              ...o,
              path: section.title + " -> " + o.path
            }
          })
        ]
      }
    })
    return unansweredRecommendedFields
  }

  _renderRows(){
    let {
      group,
      section,
      editable,
      submission,
      subSectionCreatableTemplate
    } = this.state

    return section.rows.map((row, rowIndex) => {
      return (
          <Row
              ref={ref => this.rowRefs[rowIndex] = ref}
              row={row}
              index={rowIndex}
              editable={editable}
              group={group}
              submission={submission}
              onUpdated={rowData => {
                let sectionData = General.clone(section)
                sectionData.rows[rowIndex] = rowData
                this.props.onUpdated(sectionData)
              }}
              onBlur={this.props.onBlur}
              onDuplicate={rowData => {
                let sectionData = General.clone(section)

                sectionData.rows[rowIndex] = rowData

                this.props.onDuplicate(sectionData)
              }}
          />
      )
    })
  }

  _renderSubSections(){
    let {
      index,
      section,
      level,
      editable,
      submission,
      subSectionsTitle,
      subSectionsCreatable,
      subSectionCreatableTemplate
    } = this.state

    return (
      <>
        {
          section.sections.map((subSection, subSectionIndex) => {
            return (
                <Section
                    ref={ref => this.subSectionRefs[subSectionIndex] = ref}
                    key={subSectionIndex}
                    section={subSection}
                    submission={submission}
                    index={subSectionIndex}
                    editable={editable}
                    group={subSectionsCreatable ? subSectionIndex : 0}
                    onUpdated={subSectionData => {
                      section.sections[subSectionIndex] = subSectionData
                      this.props.onUpdated(section)
                    }}
                    level={level + 1}
                    onDelete={() => {
                      section.sections.splice(subSectionIndex, 1)
                      this.props.onUpdated(section)
                    }}
                    onBlur={this.props.onBlur}
                    onDuplicate={section => {
                      let sectionData = General.clone(section)

                      sectionData.sections.push(section)
                      this.props.onUpdated(sectionData)
                    }}
                />
            )
          })
        }
        {
          (subSectionsCreatable && editable) && (
            <div className="row mt-5">
              <div className="col-md-12 mb-10">
                <a className="btn btn-light-primary"
                   onClick={() => {
                     let sectionData = General.clone(section)
                     let group = sectionData.sections.length
                     let blankSubSection = Form.resetAnswers(subSectionCreatableTemplate, group)
                     section.sections.push(blankSubSection)
                     this.props.onUpdated(section)
                   }}
                >
                  <i className="la la-plus"></i>
                  Add {subSectionsTitle}
                </a>
              </div>
            </div>
          )
        }
      </>
    )
  }

  _renderTemplateSetting(){
    let {
      section,
      submission,
    } = this.state

    if(!submission?.template || AuthManager.currentUser.user.role != "company_member"){
      return null
    }

    return (
      <Tooltip
        title={<p style={{ fontSize: 12, padding: 8, marginBottom: 0}}>Settings</p>}
        fontSize={16}
        placement="top"
        arrow
        className="mb-1"
      >
        <a
          className="ms-3"
          onClick={(e) => {
            if(AuthManager.currentUser.user.role != "company_member"){
              return
            }
            this.setState({ showTemplatePropertyModal: true })
          }}
        >
          <span class="svg-icon-help svg-icon-2x">
            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="18px" height="18px" viewBox="0 0 24 24" version="1.1">
              <defs/>
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <rect x="0" y="0" width="24" height="24"/>
                  <path d="M5,8.6862915 L5,5 L8.6862915,5 L11.5857864,2.10050506 L14.4852814,5 L19,5 L19,9.51471863 L21.4852814,12 L19,14.4852814 L19,19 L14.4852814,19 L11.5857864,21.8994949 L8.6862915,19 L5,19 L5,15.3137085 L1.6862915,12 L5,8.6862915 Z M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z" fill="#000000"/>
              </g>
            </svg>
          </span>
        </a>
      </Tooltip>
    )

  }

  render() {
    let {
      index,
      section,
      level,
      editable,
      submission,
      subSectionsTitle,
      subSectionsCreatable,
      subSectionCreatableTemplate,
      showTemplatePropertyModal
    } = this.state

    if(section.template_property?.hidden && !submission.show_hidden_fields){
      return null
    }

    let order = index + 1
    if(section.title === "Tariff Code"){
      order -= 1
    }
    let id = `${General.removeSpecialCharacters(section.title.replaceAll(" ", ""))}_${level}`
    let headerId = `${id}_header_${order}`
    let bodyId = `${id}_body_${order}`

    let forceExpanded = level > 0
    let showClassName = forceExpanded ? `show` : ""

    let title = section.title
    let deletable = false

    if(section.box_code){
      title += ` [${section.box_code}]`
    }
    if(section.repeatable){
      title = `#${order}`
      deletable = editable
    }

    if(section.title === "Product"){
      let answer = section.rows[0].fields[0].answer

      if(answer?.shipment_item?.name){
        title = ""
        if(this.props.showProductIndexes){
          title = `#${order} `
        }
        title += answer.shipment_item.name
      }
    }

    return (
      <div className={`accordion-item level-${level}`}>
        <h2 className="accordion-header" id={headerId}>
          {
              deletable &&
              <>
                <a
                    href="javascript:;"
                    data-repeater-delete=""
                    className="btn btn-sm btn-light-danger section-delete"
                    onClick={() => this.props.onDelete()}
                >
                  <i className="la la-trash-o fs-3"></i>Delete {section.title}
                </a>
              </>
          }
          <button
              className={`accordion-button fs-4 fw-semibold collapsed`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={forceExpanded ? null : `#${bodyId}`}
              aria-expanded={"false"}
              aria-controls={bodyId}
          >
            {title}

            {this._renderTemplateSetting()}

          </button>
        </h2>
        <div
            id={bodyId}
            className={`accordion-collapse collapse ${showClassName}`}
            aria-labelledby={headerId}
            data-bs-parent="#importParties"
        >
          <div className="accordion-body">
          { section.sub_sections_top ? (
             <>
               {this._renderSubSections()}
               {this._renderRows()}
             </>
           ) : (
             <>
               {this._renderRows()}
               <br/><br/>
               {this._renderSubSections()}
             </>
           )
          }
          </div>
        </div>

        { showTemplatePropertyModal &&
          <TemplateProperty
            show={showTemplatePropertyModal}
            title={section.title}
            templateProperty={section.template_property}
            toggleEditable={false}
            onHide={() => this.setState({ showTemplatePropertyModal: false })}
            onUpdated={(data) => {
              data.section = section.id
              section.template_property = data
              this.setState({ section, showTemplatePropertyModal: false })
            }}
          />
        }

      </div>
    )
  }
}
